import {Component} from '@angular/core';
/**
 * \@title Basic slide-toggles
 */
export class SlideToggleOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'slide-toggle-overview-example',
  templateUrl: 'slide-toggle-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SlideToggleOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
SlideToggleOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SlideToggleOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
